<div class="modal-content">
  <div class="container-fluid">
    <br /><br /><br /><br />
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <h4 class="page-title">Terminal Management Configuration Audit</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row" id="content" #content>
      <div class="col-12">
        <div class="card-box">
          <ul ngbNav #nav="ngbNav" class="nav nav-tabs" (activeIdChange)="initTable($event)">
            <li [ngbNavItem]="1">
              <a ngbNavLink>Terminal configuration audit details</a>
              <div class="row">
                <div class="col-12 mb-2">
                  <table datatable [dtOptions]="dtOptions" class="table table-striped mb-0">
                    <thead>
                      <tr>
                        <th style="width:5px;"> Id</th>
                        <th style="width:80px"> Changed On </th>
                        <th style="width:120px"> Changed By </th>
                        <th style="width:50px"> Source </th>
                        <th style="width:150px"> Name </th>
                        <th style="width:100px"> Active </th>
                        <th style="width:100px"> Base currency </th>
                        <th style="width:100px"> Config type </th>
                        <th style="width:50px"> Country code </th>
                        <th style="width:50px"> Disable Hot cards </th>
                        <th style="width:50px"> Drop Idle connections </th>
                        <th>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let config of terminalConfigViewModel">
                        <td style="font-size:12px"> {{ config.id }} </td>
                        <td style="font-size:12px"> {{ config.changedOn | date:'MMMM d, y, h:mm:ss a' }} </td>
                        <td style="font-size:12px"> {{ config.changedBy }} </td>
                        <td style="font-size:12px"> {{ config.source }} </td>
                        <td style="font-size:12px"> {{ config.name }} </td>
                        <td style="font-size:12px"> {{ config.active == 1 ? "Active" : "InActive"}} </td>
                        <td style="font-size:12px"> {{ config.baseCurrency }} </td>
                        <td style="font-size:12px"> {{ (config.configType == 1 ? "TermApp" : "PostTerm") }} </td>
                        <td style="font-size:12px"> {{ config.countryCode }} </td>
                        <td style="font-size:12px"> {{ config.disableHotcards}} </td>
                        <td style="font-size:12px"> {{ config.dropIdleConnections }} </td>
                        <td style="font-size:12px">
                          <input type="button" value="..." class="btn btn-success" (click)="openReadMoreDialog(config)">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="page-title-box">
                    <div class="page-title-right">
                      <input type="button" value="Print" class="btn btn-success" (click)="print()">
                      &nbsp;
                      <input type="button" value="Export to CSV" class="btn btn-success" (click)="DownloadCardAcceptorAuditDetailsCsv()">
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
